import { useTheme } from '@mui/material';
import Chip, { chipClasses, ChipProps } from '@mui/material/Chip';

type QuickFilterChipProps = Omit<ChipProps, 'sx' | 'variant'> & {
  isHidden?: boolean;
  isSelected: boolean;
  maxWidth?: string;
};

export default function QuickFilterChip({
  isHidden,
  isSelected,
  maxWidth,
  ...chipProps
}: QuickFilterChipProps) {
  const theme = useTheme();

  return (
    <Chip
      {...chipProps}
      aria-pressed={isSelected}
      variant="outlined"
      sx={{
        [`&.${chipClasses.root}.${chipClasses.outlined}`]: {
          bgcolor: isSelected
            ? theme.brandV2.colors.treadGray7
            : theme.semantic.surfaceRaised,
          borderColor: isSelected ? 'transparent' : theme.brandV2.colors.treadGray7,
          cursor: 'pointer',
          maxWidth,
          visibility: isHidden ? 'hidden' : 'visible',
          width: 'auto',
        },
        [`& .${chipClasses.icon}`]: {
          color: isSelected
            ? theme.brandV2.colors.treadOrange
            : theme.brandV2.colors.treadBlack,
          fontSize: '16px',
        },
        [`& .${chipClasses.label}`]: {
          color: theme.brandV2.colors.treadBlack,
          fontSize: '12px',
          fontWeight: isSelected ? 500 : 400,
        },
      }}
    />
  );
}
